"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pillStyles = void 0;
const Utils_1 = require("../../../../utils/Utils");
const typography_1 = require("../typography");
const _rootPartial = Object.assign(Object.assign({}, typography_1.typographyValues.$textSecondary000), { backgroundColor: '$primary300', borderRadius: '4px', color: '$neutral100', margin: 0, padding: '$s2', width: 'fit-content' });
exports.pillStyles = {
    default: (0, Utils_1.constructVariantStyles)([_rootPartial]),
};
